export enum ReportsWorkspaceCapabilityAccessOperation {
    create = "121c292a-729e-4ee7-8521-2a6340b690d1",
    read = "b437ba1d-8101-47a8-8338-6f743bce3111",
    update = "c00b84bb-3067-4aaf-9304-2b50a8f70f5b",
    delete = "4c4b7004-e406-4ffa-9d87-c59ca6323578",
}
